import ChatList from './ChatList';
// import ChatRoom from './ChatRoom';

// export default { ChatList, ChatRoom };
export default ChatList;
